export default {
  title: 'Order Methods',
  paywall: {
    live_title: '{{name}} is live!',
  },
  tabs: {
    general: 'General',
    pickup: 'Pickup',
    delivery: 'Delivery',
    table_ordering: 'Table ordering',
  },
  modals: {
    update_confirmation: {
      title: 'Are you sure you want save the new changes?',
      buttons: {
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
    },
    switch_live_orders: {
      titles: {
        disable: 'Are you sure you want to disable live orders?',
        enable: 'Are you sure you want to turn ON live orders?',
      },
      buttons: {
        yes: 'Yes',
        no: 'No',
      },
    },
  },
  toasts: {
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
    table_ordering_saved: 'Table ordering saved',
  },
};
